import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const HeaderContainer = styled(Box, {
  shouldForwardProp: prop =>
    !["withoutMarginTop", "withoutMarginBottom", "displayAgentDetails"].includes(prop)
})(({ theme }) => ({
  backgroundColor: "transparent",
  margin: "0 auto !important",
  "& span": {
    width: "100%",
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: "500",
    [theme.breakpoints.up("sm")]: {
      fontSize: "24px",
      lineHeight: "32px"
    }
  }
  // [theme.breakpoints.only("xs")]: {
  //   display: "none"
  // }
}));

export const FinanceType = styled(Typography)(() => ({
  color: "red"
}));

export const HeaderTitleInner = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  color: theme.palette.header.title
}));

export const AgentDetails = styled("span")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexShrink: 0,
  width: "100%"
}));

export const LogoutButton = styled(Box)(() => ({
  cursor: "pointer",
  textDecoration: "underline"
}));

export const ShowName = styled(Typography)(() => ({
  display: "block",
  color: "red"
}));

export const HideName = styled(Typography)(() => ({
  display: "none"
}));
